import { render, staticRenderFns } from "./ServicoOperadora.vue?vue&type=template&id=37550a38&"
import script from "./ServicoOperadora.vue?vue&type=script&lang=js&"
export * from "./ServicoOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports